module.exports = __webpack_public_path__ + "img/vehicleCircleFerry.3f6cf05c.svg";